import { CommonLaboratoryDatasource } from '@/shared/resources/datasources/common/common-laboratory-datasource'
import DiagnosisCaseFilterServices from '@/modules/diagnosisModule/services/DiagnosisCaseFilterServices'
import { Nullable } from '@/shared/types/app.types'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { omitBy, isNil } from 'lodash'
import { GridUtils } from '@/shared/util/grid-utils'
import { DiagnosisCaseDatasourceSelectedOption } from '@/modules/diagnosisModule/views/grid/config/diagnosis-case-datasource.model'

export class DiagnosisCaseDatasource<T> extends CommonLaboratoryDatasource<T> {
    private readonly _viewAllEnabled: boolean
    private readonly _externalFilterModel: Nullable<CommonFilterModel>
    private readonly _selectedOption: Nullable<DiagnosisCaseDatasourceSelectedOption>
    private readonly _responsibility: Nullable<string>

    private get _isSelectedCasesWithConsults(): boolean {
        return `${this._selectedOption?.id}`.startsWith('CONSULTATION_') ?? false
    }

    constructor(laboratoryId: number, viewAllEnabled: boolean, responsibility: Nullable<string>, selectedOption: Nullable<DiagnosisCaseDatasourceSelectedOption>, externalFilterModel?: CommonFilterModel) {
        super(laboratoryId)
        this._viewAllEnabled = viewAllEnabled
        this._responsibility = responsibility
        this._selectedOption = selectedOption
        this._externalFilterModel = omitBy(externalFilterModel, isNil)
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        const filter =
            this._externalFilterModel && !this._isSelectedCasesWithConsults
                ? Object.assign(filterModel, this._externalFilterModel)
                : filterModel

        if (filter.lastAmendmentDate) {
            if (!filter.lastAmendmentDate.values.length) {
                delete filter.lastAmendmentDate
            } else {
                filter.lastAmendmentDate =
                    GridUtils.getDateFilterModel(
                        filter.lastAmendmentDate.values[0] === 'true'
                            ? 'isNotNull'
                            : 'isNull')
            }
        }

        if (this._isSelectedCasesWithConsults) {
            return DiagnosisCaseFilterServices.getConsultationsCases(
                this.laboratoryId,
                filterModel,
                params,
                this._selectedOption?.task?.url
            )
        } else {
            if (this._viewAllEnabled) {
                const _params = {
                    ...params,
                    caseSituation: this._selectedOption?.caseSituation
                }
                return DiagnosisCaseFilterServices.getAllCases(this.laboratoryId, filter, _params)
            } else {
                const _params = {
                    ...params,
                    caseSituation: this._selectedOption?.caseSituation,
                    responsibility: this._responsibility
                }
                return DiagnosisCaseFilterServices.getMyOwnCases(this.laboratoryId, filter, _params)
            }
        }
    }
}
